import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Bread from "../../common/Bread";
import "../Branch/branch.scss";
import BranchMap from "../../components/BranchMap";
import Loader from "../../common/Loader";
import ATMList from "../../components/ATMList";

const ATM = () => {
  const [selected, setSelected] = React.useState({
    id: null,
    lat: null,
    lng: null,
  });

  // console.log("selected =>", typeof selected, selected);

  const callbackSelect = ({ id, lat, lng }) => {
    setSelected({ id: id, lat: lat, lng: lng });
  };

  const handleReset = () => {
    setSelected({
      id: null,
      lat: null,
      lng: null,
    });
  };

  const breadcrumList = {
    image: "",
    title: "ATM Locations",
    l1: "Home",
    l2: "ATMs",
    l3: "",
  };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["atmData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/atm`)
        .then((res) => res.data),
  });

  if (isFetching) return <Loader />;

  if (isLoading) return <Loader />;

  if (error) return "An error has occurred: " + error.message;

  return (
    <Bread data={breadcrumList}>
      <Tabs className="branchesPageTabContainer" defaultIndex={0}>
        <TabList className="branchesPageTabsButtonContainer">
          <Tab className="branchesPageTabButton" onClick={handleReset}>
            Inside Kathmandu Valley
          </Tab>

          <Tab className="branchesPageTabButton" onClick={handleReset}>
            Outside Valley
          </Tab>
        </TabList>

        <TabPanel>
          <div className="branchesPageContainer">
            <ATMList
              data={data?.branch.en.filter(
                (i) => i.Location.toLowerCase() === "inside"
              )}
              callbackSelect={callbackSelect}
            />
            <div className="branchesMapContainer">
              <BranchMap
                data={data?.branch.en.filter(
                  (i) => i.Location.toLowerCase() === "inside"
                )}
                selected={selected}
              />
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="branchesPageContainer">
            <ATMList
              data={data?.branch.en.filter(
                (i) => i.Location.toLowerCase() === "outside"
              )}
              callbackSelect={callbackSelect}
            />
            <div className="branchesMapContainer">
              <BranchMap
                data={data?.branch.en.filter(
                  (i) => i.Location.toLowerCase() === "outside"
                )}
                selected={selected}
              />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </Bread>
  );
};

export default ATM;
